import { SiteLink as Link } from '../../components/SiteLink';
import { PageShell, GetStarted } from '../../components';
import { FOUNDER_BLOG_URL } from '../../lib/appUrls';
import { POSTS, formatDate, postPath } from '../../content';

/**
 * statio.dev/blog. Posts about MCP, agent access and how Statio works. The
 * founder's personal writing stays on Logical Bytes and is linked from here
 * and from the footer, so the two blogs point at each other.
 */
export default function BlogIndex() {
  return (
    <PageShell>
      <div className="s-wrap bl">
        <header className="bl-head">
          <h1>The Statio blog</h1>
          <p className="bl-lede">Writing on MCP, AI agent access and what it takes to let an agent touch a real API.</p>
        </header>
        <section className="bl-index" aria-label="Posts">
          <ul>
            {POSTS.map((p) => (
              <li key={p.slug}>
                <Link className="thumb" to={postPath(p.slug)} tabIndex={-1} aria-hidden="true">
                  <img src={p.image} alt="" width={1200} height={630} loading="lazy" decoding="async" />
                </Link>
                <div>
                  <span className="m">
                    {formatDate(p.date)} · {p.readMinutes} min read · {p.author}
                  </span>
                  <h2>
                    <Link to={postPath(p.slug)}>{p.title}</Link>
                  </h2>
                  <p>{p.description}</p>
                </div>
              </li>
            ))}
          </ul>
          <p className="bl-founder">
            Looking for posts on Go, CI and side projects? Those are on the founder&apos;s blog,{' '}
            <a className="s-link" href={FOUNDER_BLOG_URL} target="_blank" rel="noopener noreferrer">
              Logical Bytes
            </a>
            .
          </p>
        </section>
      </div>
      <GetStarted />
    </PageShell>
  );
}
